import { render, staticRenderFns } from "./AnalysesList.vue?vue&type=template&id=0ff39552&scoped=true&"
import script from "./AnalysesList.vue?vue&type=script&lang=ts&"
export * from "./AnalysesList.vue?vue&type=script&lang=ts&"
import style0 from "./AnalysesList.vue?vue&type=style&index=0&id=0ff39552&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff39552",
  null
  
)

export default component.exports